import { basetheme } from '../base/base.theme'

import './theme.css'

export const testtheme = basetheme
export default testtheme
